<template>
  <div class="flex flex-col items-center mt-8 md:mt-16">
    <div class="w-[94%] md:w-[75%]">
      <h2 class="text-3xl font-semibold text-mainColor text-center">Our Partners</h2>

      <Swiper
        :modules="[Autoplay]"
        :slides-per-view="2"
        :space-between="20"
        :navigation="true"
        :breakpoints="{
          640: { slidesPerView: 3 },
          768: { slidesPerView: 4 },
          1024: { slidesPerView: 5 },
        }"
        :autoplay="{
          delay: 6000,
          disableOnInteraction: false
        }"
        loop
        class="py-4"
      >
        <SwiperSlide v-for="item in items" :key="item.id">
          <div class="shadow-md rounded-md bg-white flex justify-center items-center p-4 h-32">
            <img :src="item.imageUrl" class="w-auto h-24 object-contain" />
          </div>
        </SwiperSlide>
      </Swiper>
    </div>
  </div>
</template>

<script>
import { db } from "@/firebaseConfig";
import { collection, getDocs, query, orderBy } from "firebase/firestore";

// Swiper
import { Swiper, SwiperSlide } from "swiper/vue";
import { Autoplay } from "swiper/modules";

// Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/autoplay";

export default {
  name: "OurPartner",
  components: { Swiper, SwiperSlide },

  data() {
    return { items: [] };
  },

  mounted() {
    this.fetchOurPartner();
  },

  methods: {
    async fetchOurPartner() {
      const q = query(collection(db, "ourPartner"), orderBy("orderNumber", "asc"));
      const snapshot = await getDocs(q);
      this.items = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
    },
  },

  setup() {
    return {
      Autoplay,
    };
  },
};
</script>
